import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const isLoginIdExists = (loginId, tenantName) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.USER_MANAGEMENT.IS_LOGINID_EXISTS(loginId, tenantName),
    "",
    cancelToken
  );
};

export default isLoginIdExists;
